import { render, staticRenderFns } from "./Sdemo.vue?vue&type=template&id=eb7bf150&scoped=true&"
import script from "./Sdemo.vue?vue&type=script&lang=js&"
export * from "./Sdemo.vue?vue&type=script&lang=js&"
import style0 from "./Sdemo.vue?vue&type=style&index=0&id=eb7bf150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7bf150",
  null
  
)

export default component.exports